'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gradation = require('../gradation');

exports.default = {
  gradation: _gradation.convenient,
  flavour: ['long_convenient', 'long'],
  units: ['now', 'minute', 'hour', 'day', 'week', 'month', 'year']
};